import { useLocation } from "react-router-dom";

/** Returns true if the user is on the login page */
export function useIsLogin() {
  const location = useLocation();
  return location.pathname === "/login";
}
